import { IntegrationMonitoringTranslations } from '../models/integration-monitoring-translaction-model';

// eslint-disable-next-line import/prefer-default-export
export const ptBR: IntegrationMonitoringTranslations = {
  title: 'Monitoramento de Integrações',
  filter: {
    expandSearch: 'Expandir busca',
    collapseSearch: 'Recolher busca',
    clear: 'Limpar filtros',
    search: 'Buscar',
    integrationType: 'Tipo de integração',
    processType: 'Tipo de processo',
    financialGroup: 'Grupo financeiro',
    carrier: 'Operadora',
    contract: 'Contrato',
    receivedPeriod: 'Período de recebimento',
    status: 'Status',
    placeholders: {
      select: 'Selecione',
      period: 'Selecione o período',
    },
    integrationTypes: {
      api: 'API',
      rpa: 'RPA',
    },
    processTypes: {
      coparticipation: 'Coparticipação',
      cadastralPosition: 'Posição Cadastral',
      carrierCadastralMovement: 'Movimentação cadastral operadora',
      clientCadastralMovement: 'Movimentação cadastral cliente',
      payroll: 'Folha',
    },
    requestStatus: {
      RECEIVED: 'Recebido',
      PROCESSING: 'Em Processamento',
      COMPLETED: 'Processado',
      COMPLETED_WITH_ERRORS: 'Processado Parcialmente',
      PROCESSED: 'Processado',
      PARTIALLY_PROCESSED: 'Processado Parcialmente',
      SUCCESS: 'Sucesso',
      ERROR: 'Erro',
    },
  },
  indicators: {
    totalRequests: 'Total de requisições',
    totalWithErrors: 'Requisições com erro',
    periodDays: 'Últimos {n} dias',
    periodDay: 'Último dia',
  },
  table: {
    headers: {
      carrier: 'Operadora',
      financialGroup: 'Grupo Financeiro',
      contract: 'Contrato',
      competence: 'Competência',
      status: 'Status',
      receivedAt: 'Data/hora do recebimento',
      actions: 'Ações',
    },
    loading: 'Carregando requisições...',
    noData: 'Nenhuma requisição encontrada para os filtros informados.',
    noResult: 'Nenhum resultado encontrado.',
    batchErrorItems: 'Lote concluído com {n} item(ns) em erro.',
  },
  messages: {
    searchError: 'Erro ao buscar monitoramento de integrações.',
    requiredFilters: 'Informe o período e ao menos um filtro: operadora, grupo financeiro ou contrato.',
    exportSuccess: 'Download do JSON iniciado com sucesso.',
    exportError: 'Erro ao exportar a requisição em JSON.',
    forbiddenAccess: 'Sem permissão para monitoramento interno.',
    noPermission: 'Você não tem permissão para acessar o Monitoramento de Integrações.',
  },
  actions: { exportJson: 'Exportar requisições recebidas (JSON)' },
};
